import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-notes-dialog',
  templateUrl: './companies-notes-dialog.component.html',
  styleUrls: ['./companies-notes-dialog.component.scss'],
})
export class CompaniesNotesDialogComponent {
  is_stand_by_note_running: boolean = false;
  company_id?: string;
  stand_by_notes?: string;

  company_stand_by_notes_form_group: FormGroup;
  error_matcher: FormErrorStateMatcher;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private error_service: ErrorService,
    private companies_service: CompaniesService,
    private form_service: FormService,
  ) {
    this.company_id = data.company_id;
    this.company_stand_by_notes_form_group = this.form_service.company_stand_by_notes_form_group;
    this.stand_by_notes = data.stand_by_notes;
    this.error_matcher = this.form_service.matcher;
  }

  ngOnInit(): void {
    this.company_stand_by_notes_form_group.get(this.form_service.stand_by_notes_label)?.setValue(this.stand_by_notes);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onArchiveNoteClick(): void {
    if (this.company_id) {
      const note = this.company_stand_by_notes_form_group.get(this.form_service.stand_by_notes_label)?.value;
      this.standByNote(this.company_id, note);
    }
  }

  standByNote(company_id: string, note: string): void {
    this.is_stand_by_note_running = true;
    this.companies_service.setStandByNote(company_id, note).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_stand_by_note_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_stand_by_note_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.company_stand_by_notes_form_group);
  }
}
